<div class="footer" fxLayout="row">
  <div fxFlex="auto" fxLayout="row" fxLayoutAlign="start center" vexContainer>
    <div class="ltr:ml-4 rtl:mr-4" fxHide fxShow.gt-sm>
      <span> Registered Aument {{ currentYear | date: 'yyyy' }}</span>
    </div>
  </div>
</div>
